// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__qO-m3","info":"UpdateTermsInfo_info__1MLYZ"};